module.exports = __webpack_public_path__ + "img/E20.cf4ad3aa.png";